/* eslint camelcase: 0 */

import { createDetailUrlFromResource } from "../../../../server/utils/createUrls";
import returnBreadcrumbs from "../../../../server/lib/helpers/breadcrumbs";

function getPlaceFromBreadcrumbs(breadcrumbs, placeType) {
  const place = breadcrumbs.filter((crumb) => crumb.type === placeType);
  return place.length ? place[0].title : "";
}

function getPlaceFullName(place) {
  let placeAncestry = [];

  if (Array.isArray(place.ancestry)) {
    placeAncestry = place.ancestry.map((p) => p.name).reverse();

    if (place.placeType !== "country") {
      placeAncestry.push(place.name);
    }

    return placeAncestry;
  } else if (place && place.ancestry) {
    placeAncestry.push(place.ancestry.name, place.name);

    return placeAncestry;
  }

  return placeAncestry;
}

export default function editUrl(poi) {
  const breadcrumbs = poi.containingPlace ? returnBreadcrumbs(poi.containingPlace.ancestry) : [];

  const city = getPlaceFromBreadcrumbs(breadcrumbs, "city") || (poi.containingPlace && (
    poi.containingPlace.placeType === "region" ? poi.containingPlace.name : "Not Provided"
  )) || "Not Provided";

  const country = poi.containingPlace && poi.containingPlace.placeType !== "country" ?
    getPlaceFromBreadcrumbs(breadcrumbs, "country") : "";

  // Nashville, USA : Nashville
  const businessListingCity = (city && country) ? `${city}, ${country}` : city;

  const arrayForSlug = breadcrumbs.filter((crumb) => crumb.type !== "continent").reverse();
  arrayForSlug.push({ name: poi.name });

  // Americas -> North America -> USA -> The South -> Tennessee -> Nashville
  const placeFullName = poi.containingPlace && poi.containingPlace.ancestry ?
    getPlaceFullName(poi.containingPlace) : [];

  const baseUrl = "http://www.lonelyplanet.com/contact/business_listings/new_correction";
  const business_listing = {};
  const urlParams = [];

  const poiUrlPathname = createDetailUrlFromResource(
    poi,
    breadcrumbs.map(b => b.title),
    poi.containingPlace && poi.containingPlace.id,
  );

  business_listing.business_name = poi.name;
  business_listing.business_type = poi.poiType;
  business_listing.city = businessListingCity;
  business_listing.email = "";
  business_listing.neighbourhood = poi.containingPlace &&
    poi.containingPlace.placeType === "neighborhood" ?
    poi.containingPlace.name :
    "";
  business_listing.operating_hours = poi.hoursString || "";
  business_listing.place_full_name = placeFullName.join(" -> ");
  business_listing.place_id = poi.containingPlace ? poi.containingPlace.id : "";
  business_listing.poi_id = poi.id;
  business_listing.postal_code = "";
  business_listing.street = poi.address.street || "";
  business_listing.telephone = (poi.telephone && poi.telephone.national) || "";
  business_listing.typical_prices = poi.priceString;
  business_listing.website = poi.url || poi.website || "";

  Object.keys(business_listing).forEach((param) => {
    urlParams.push(`${encodeURIComponent(`business_listing[${param}]`)}=` +
      `${encodeURIComponent(business_listing[param])}`
    );
  });

  const poiUrl = encodeURIComponent(`http://www.lonelyplanet.com${poiUrlPathname}`);

  urlParams.push(`poi_url=${poiUrl}`);

  return `${baseUrl}?${urlParams.join("&")}`;
}



// WEBPACK FOOTER //
// ./assets/pois/utils/editUrl.js